import { type FunctionComponent } from 'react';
import { Button, ButtonProps } from '@atoms/Button/Button';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';

/*
The navigation button prop only accepts one of the following:
  - href and isExternalLink prop
  -  onClick prop
*/
export type NavigationButtonProps = {
  label?: string | React.ReactNode;
  loading?: boolean;
} & (
  | {
      href: string;
      isExternalLink: boolean;
      onClick?: never;
    }
  | {
      onClick: React.MouseEventHandler<HTMLButtonElement>;
      href?: never;
      isExternalLink?: never;
    }
) &
  Omit<
    ButtonProps,
    'label' | 'onClick' | 'loading' | 'isExternalLink' | 'href'
  >;

type NavigationButtonsProps = {
  buttonNext: NavigationButtonProps;
  buttonPrevious: NavigationButtonProps;
};

export const NavigationButtons: FunctionComponent<NavigationButtonsProps> = (
  props,
) => {
  const { buttonNext, buttonPrevious } = props;

  return (
    <div className="flex w-full flex-wrap items-center justify-between gap-4 py-5 font-bold">
      <Button
        data-testid="button-previous"
        id={buttonPrevious.id || 'previous-button'}
        variant="secondary"
        iconLeft={<CaretLeft />}
        label={'Previous'}
        {...buttonPrevious}
      />
      <Button
        data-testid="button-next"
        id={buttonNext.id || 'next-button'}
        variant="primary"
        iconRight={<CaretRight />}
        label={'Next'}
        {...buttonNext}
      />
    </div>
  );
};
